import { useMemo } from 'react';
import { IButton, IOverlay } from '.';

export const useOverlay = (buttonsSource: IButton[], overlay?: IOverlay) => {
  const buttons = useMemo(
    () =>
      buttonsSource.map((btn) => ({
        ...btn,
        style: {
          background: btn.backgroundColor,
          color: btn.textColor,
        },
      })),
    [buttonsSource],
  );

  const overlayDesktop = useMemo(
    () =>
      overlay && {
        src: overlay.desktopUrl,
        imgStyle: {
          width: overlay.widthDesktop,
        },
      },
    [overlay],
  );

  const overlayMobile = useMemo(
    () =>
      overlay && {
        src: overlay.mobileUrl,
        imgStyle: {
          width: overlay.widthMobile,
        },
      },
    [overlay],
  );

  return {
    buttons,
    overlayDesktop,
    overlayMobile,
  };
};
